import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { SubHeading, Checkbox } from '@leroy-merlin-br/backyard-react-ui'

const linkStyles = ({ theme }) => css`
  label: link;

  color: ${theme.colors.p600};
`

const wrapperFieldStyles = ({ theme, hasError }) => css`
  label: wrapper_field;

  margin-bottom: ${hasError ? theme.spacings.mega : theme.spacings.bit};
  margin-top: ${theme.spacings.mega};

  position: relative;

  span {
    right: ${theme.spacings.kilo};
    top: 35px;
    position: absolute;
  }
`

const complementLabelStyles = ({ theme }) => css`
  label: complement-label;

  font-weight: ${theme.font.weight.semibold};

  span {
    font-style: italic;
  }
`

const newsletterOptionsWrapperStyles = ({ theme }) => css`
  label: newsletter-options-wrapper;

  padding-left: 26px;
  margin-bottom: ${theme.spacings.byte};
`

const generalCheckboxStyles = ({ isIndeterminate }) =>
  isIndeterminate &&
  css`
    & ~ label::after {
      top: calc(50% - 5px);
    }
  `

export const Link = styled('a')(linkStyles)
export const WrapperField = styled('div')(wrapperFieldStyles)
export const ComplementLabel = styled(SubHeading)(complementLabelStyles)
export const NewsletterOptionsWrapper = styled('div')(
  newsletterOptionsWrapperStyles
)
export const GeneralCheckbox = styled(Checkbox)(generalCheckboxStyles)
